window.addEventListener("click", function (e) {
  if (e.target.classList.contains("mfn-attachment-link")) {
    e.preventDefault();
    window.open(e.target.href, "_blank");
  }
});
